import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1)
const _hoisted_3 = { class: "sm:col-span-5 main-content" }
const _hoisted_4 = {
  key: 0,
  class: "question-label"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slider = _resolveComponent("Slider")!
  const _component_BackNextButtons = _resolveComponent("BackNextButtons")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.classes?.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            (_ctx.config.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("span", null, null, 512), [
                    [_directive_t, _ctx.config.title]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.config.textPart1)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: "mt-4",
                  innerHTML: _ctx.$t(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            (_ctx.config.textPart2)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 2,
                  class: "mt-4",
                  innerHTML: _ctx.$t(_ctx.config.textPart2, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("p", {
              class: _normalizeClass(["mt-4", _ctx.config.classes?.questionClass]),
              innerHTML: _ctx.$t(_ctx.config.question, {name: _ctx.state.nickname.value})
            }, null, 10, _hoisted_7),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sliderKeys, (sliderDef) => {
              return (_openBlock(), _createElementBlock("div", {
                key: sliderDef.key,
                class: "justify-items-stretch flex flex-col mt-8 mb-8 w-full"
              }, [
                (sliderDef.text)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: _normalizeClass(["font-bold text-project text-2xl", _ctx.config.classes?.sliderTextClass]),
                      innerHTML: _ctx.$t(sliderDef.text, {name: _ctx.state.nickname.value})
                    }, null, 10, _hoisted_8))
                  : _createCommentVNode("", true),
                (_ctx.config.sliderSubtext)
                  ? (_openBlock(), _createElementBlock("small", {
                      key: 1,
                      innerHTML: _ctx.$rt(_ctx.config.sliderSubtext)
                    }, null, 8, _hoisted_9))
                  : _createCommentVNode("", true),
                _createVNode(_component_Slider, {
                  class: _normalizeClass(["w-full md:w-3/4", _ctx.config.classes?.sliderClass]),
                  min: _ctx.config.answerMin,
                  max: _ctx.config.answerMax,
                  step: _ctx.config.answerStep,
                  alternate: _ctx.config.sliderAlternate,
                  value: _ctx.state.answers.value?.[sliderDef.key],
                  unit: _ctx.$t(_ctx.config.answerUnit, {name: _ctx.state.nickname.value}),
                  onChange: ($event: any) => (_ctx.answer( $event, sliderDef.key, { [sliderDef.key]: `${_ctx.$t(_ctx.config.question)} - ${_ctx.$t(sliderDef.text)}` })),
                  options: _ctx.config.answerOptions
                }, null, 8, ["min", "max", "step", "alternate", "class", "value", "unit", "onChange", "options"])
              ]))
            }), 128)),
            _createVNode(_component_BackNextButtons, {
              class: "mt-8 hidden sm:block",
              "go-to": _ctx.goTo,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveAll())),
              "next-screen": _ctx.config.screenNext
            }, null, 8, ["go-to", "next-screen"])
          ]),
          _createElementVNode("div", {
            class: "sm:col-span-3 h-full min-h-50vh flex-col items-center flex",
            style: _normalizeStyle(`background-image: ${_ctx.config.bgImage}; background-size: cover;  background-repeat: no-repeat; background-position: center; ${_ctx.config.bgStyles}`)
          }, null, 4),
          _createVNode(_component_BackNextButtons, {
            class: "mt-8 sm:hidden",
            "go-to": _ctx.goTo,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveAll())),
            "next-screen": _ctx.config.screenNext
          }, null, 8, ["go-to", "next-screen"])
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}